<!--inicio header-->
<nav class="navbar navbar-expand-lg navbar-light bg-light shadow sticky-top" >
    <div class="container-fluid">
      <a class="navbar-brand">
        <img src="../assets/img/logo-sofofa-main.svg" class="logo-cabecera pull-left" />
      </a>

      <div class="float-end">
        <img src="../assets/img/canal-main.svg" class="logo-cabecera" style="max-height:46px;margin-right: 25px;">
      </div>
   
    </div>
  </nav>
  <!--fin header-->
  


  